import React from 'react';

export const Intro = () => (
  <section className="o-section  t-section  ">
    <div className="o-section__header-bg  t-section__header"></div>
    <div className="o-section__content-bg  t-section__content"></div>
    <div className="o-container">
      <div className="o-section__container">
        <header className="o-section__header  t-section__header">
          <div className="o-content">
            <h2 className="o-section__heading">Intro</h2>
          </div>
        </header>
        <div className="o-section__content  t-section__content  ">
          <div className="o-content">
            <div className="c-intro">
              <div className="o-content__body">
                <p>
                  My passion about the web is quite old, as a software engineer, I've touched all the stack: server, database,
                  back-end and front-end. In the last years, I focused more on the front-end, (AngularJS and React) getting in
                  love with the single page applications stack and Javascript.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js